// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterDownloadApp_wrapper__2fsUz","badgeWrapper":"FooterDownloadApp_badgeWrapper__2PYPv","badge":"FooterDownloadApp_badge__2I4y2"};